import React from 'react';
export function SpecificationsSection() {
  return <div className="mt-12 bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-3555">
      <div className="bg-navy py-4 px-8" data-id="element-3556">
        <h2 className="text-2xl font-bold text-white" data-id="element-3557">
          Technical Specifications
        </h2>
      </div>

      <div className="p-8" data-id="element-3558">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-3559">
          {/* Left Column Specs */}
          <div className="space-y-10" data-id="element-3560">
            <div data-id="element-3561">
              <h3 className="text-xl font-bold text-navy border-b border-gray-200 pb-2 mb-4" data-id="element-3562">
                Useful Workpiece sizes
              </h3>
              <div className="space-y-2" data-id="element-3563">
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3564">
                  <span className="font-medium text-gray-700" data-id="element-3565">
                    Workpiece diameter
                  </span>
                  <span className="text-gray-900" data-id="element-3566">1-120 mm</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3567">
                  <span className="font-medium text-gray-700" data-id="element-3568">
                    Workpiece length
                  </span>
                  <span className="text-gray-900" data-id="element-3569">1-100 mm</span>
                </div>
              </div>
            </div>

            <div data-id="element-3570">
              <h3 className="text-xl font-bold text-navy border-b border-gray-200 pb-2 mb-4" data-id="element-3571">
                Strokes
              </h3>
              <div className="space-y-2" data-id="element-3572">
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3573">
                  <span className="font-medium text-gray-700" data-id="element-3574">X-stroke</span>
                  <span className="text-gray-900" data-id="element-3575">400 mm</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3576">
                  <span className="font-medium text-gray-700" data-id="element-3577">Z-stroke</span>
                  <span className="text-gray-900" data-id="element-3578">400 mm</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3579">
                  <span className="font-medium text-gray-700" data-id="element-3580">Guideways</span>
                  <span className="text-gray-900" data-id="element-3581">sliding guideways</span>
                </div>
              </div>
            </div>

            <div data-id="element-3582">
              <h3 className="text-xl font-bold text-navy border-b border-gray-200 pb-2 mb-4" data-id="element-3583">
                General
              </h3>
              <div className="space-y-2" data-id="element-3584">
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3585">
                  <span className="font-medium text-gray-700" data-id="element-3586">
                    Dimensions (L x W x H)
                  </span>
                  <span className="text-gray-900" data-id="element-3587">2700 x 1750 x 1750 mm</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3588">
                  <span className="font-medium text-gray-700" data-id="element-3589">Weight</span>
                  <span className="text-gray-900" data-id="element-3590">approx 2.100 kg</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column Specs */}
          <div className="space-y-10" data-id="element-3591">
            <div data-id="element-3592">
              <h3 className="text-xl font-bold text-navy border-b border-gray-200 pb-2 mb-4" data-id="element-3593">
                Spindle
              </h3>
              <div className="space-y-2" data-id="element-3594">
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3595">
                  <span className="font-medium text-gray-700" data-id="element-3596">
                    Spindle type 1
                  </span>
                  <span className="text-gray-900" data-id="element-3597">
                    5.000 1/min / 7,7 KW / 43 Nm
                  </span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3598">
                  <span className="font-medium text-gray-700" data-id="element-3599">
                    Spindle type 2
                  </span>
                  <span className="text-gray-900" data-id="element-3600">
                    8.000 1/min / 7,7 KW / 28 Nm
                  </span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3601">
                  <span className="font-medium text-gray-700" data-id="element-3602">
                    Clamping cylinder
                  </span>
                  <span className="text-gray-900" data-id="element-3603">pneumatic version</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3604">
                  <span className="font-medium text-gray-700" data-id="element-3605">
                    Maximum spindle bar capacity
                  </span>
                  <span className="text-gray-900" data-id="element-3606">42 or 32 mm</span>
                </div>
              </div>
            </div>

            <div data-id="element-3607">
              <h3 className="text-xl font-bold text-navy border-b border-gray-200 pb-2 mb-4" data-id="element-3608">
                Options available
              </h3>
              <div className="space-y-2" data-id="element-3609">
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3610">
                  <span className="font-medium text-gray-700" data-id="element-3611">
                    Gang tooling
                  </span>
                  <span className="text-gray-900" data-id="element-3612">standard</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3613">
                  <span className="font-medium text-gray-700" data-id="element-3614">Turret</span>
                  <span className="text-gray-900" data-id="element-3615">Optional</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3616">
                  <span className="font-medium text-gray-700" data-id="element-3617">Live tools</span>
                  <span className="text-gray-900" data-id="element-3618">Optional</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3619">
                  <span className="font-medium text-gray-700" data-id="element-3620">Tailstock</span>
                  <span className="text-gray-900" data-id="element-3621">Optional</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3622">
                  <span className="font-medium text-gray-700" data-id="element-3623">Subspindle</span>
                  <span className="text-gray-900" data-id="element-3624">Optional</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3625">
                  <span className="font-medium text-gray-700" data-id="element-3626">Y-axis</span>
                  <span className="text-gray-900" data-id="element-3627">not available</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-gray-50 rounded" data-id="element-3628">
                  <span className="font-medium text-gray-700" data-id="element-3629">Barfeeder</span>
                  <span className="text-gray-900" data-id="element-3630">Optional</span>
                </div>
                <div className="flex justify-between py-2 px-3 bg-white rounded" data-id="element-3631">
                  <span className="font-medium text-gray-700" data-id="element-3632">Automation</span>
                  <span className="text-gray-900" data-id="element-3633">
                    Robot and integrated solutions optional
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}